import './vendor';
import './helpers';
import './router';
import './components/social';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';
import vars from './helpers';

ieFix();
vhFix();
actualYear();
scrollToAnchor.init();

header.init();
lazyLoading.init();

const bannerSlider = () => {
	const slider = document.querySelectorAll('.js-promo-slider');

	slider.forEach((element) => {
		const $slider = $(element);
		const prevArrow = $slider.find('.js-arrow--prev');
		const nextArrow = $slider.find('.js-arrow--next');
		const $section = $slider.find('.js-promo-slider--section');

		$($section).slick({
			dots: false,
			speed: 500,
			// arrows: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			// draggable: false,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: true,
			prevArrow,
			nextArrow,
		});

		$($section).on('afterChange', () => {
			setTimeout(() => {
				const $element = $section.find('.slick-slide.slick-active');
				const $promo = $element.find('.promo');
				const type = $promo.data('type');
				const name = $promo.data('name');

				ga('send', 'event', 'banner', 'show', `${type} banner - ${name}`, {nonInteraction: true});
				ga('send', 'event', 'banner', 'banner swipe', `${type} banner - ${name}`);
			}, 100);
		});
	});
};
bannerSlider();
